import { extractFetchableIntegrationLinks } from '@buildautomaton/types';
import { injectIntegrationContentAgentPromptNote } from './build-integration-content-agent-prompt-note.js';

/** Add integration-content MCP guidance when the user prompt contains supported URLs. */
export function enrichIntegrationContentPromptForAgent(params: {
  sessionId: string;
  originalPromptText: string;
  agentPromptText: string;
}): string {
  if (!params.sessionId.trim()) return params.agentPromptText;
  if (extractFetchableIntegrationLinks(params.originalPromptText).length === 0) {
    return params.agentPromptText;
  }
  return injectIntegrationContentAgentPromptNote(params.agentPromptText, params.sessionId);
}
